import styled from "styled-components/macro";

import { motion } from "framer-motion";

export { sidePadding } from "Payments/PaymentPage/PaymentFormScreen/styles.js";

export const ScreenWrapper = styled(motion.div)``;
